import * as React from 'react';
import SearchableSelect from "../components/searchable-select/SearchableSelect";
import { ISong } from "../pages/song/types";

const TestComponent = () => {

    const parser = (song: ISong) => {
        return {
            value: song._id,
            label: `${song.singer} - ${song.title}`,
        }
    }

    return (
        <div>
            Test Component V3
            <SearchableSelect<ISong>
                uri={'/api/song/search'}
                parser={parser}
                onChange={() => {

                }}
            />
        </div>
    );
};

export default TestComponent;